module.exports = __webpack_public_path__ + "img/1.61ad1010.jpg";